import { render, staticRenderFns } from "./agent-card.vue?vue&type=template&id=224cd261&"
import script from "./agent-card.vue?vue&type=script&lang=js&"
export * from "./agent-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports